import axios from 'axios'
// import { RADAR_DATA_API_URL } from '../../env'
import { getSessionToken } from '../session'
import { normalizePhenomenon, normalizePhenomenonInput } from './normalize'

const RADAR_DATA_API_URL = process.env.REACT_APP_RADAR_DATA_API_URL

const GET = 'GET'
const POST = 'POST'
const DELETE = 'DELETE'
const PATCH = 'PATCH'

async function httpRequest(method, path, payload = null) {
    return axios({
        method,
        url: `${RADAR_DATA_API_URL}/${path}`,
        headers: {
            // 'X-CSRF-Token': getCsrfToken(),
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        withCredentials: true,
        data: payload || null
    })
}

// TODO: move normalize functions to the api consumers
const radarDataApi = {
    getRadar: async (radarId) => {
        return httpRequest(GET, `${radarId}`)
            .then(({ data, ...result }) => {
                const { phenomena, ...restData } = data

                return {
                    data: {
                        phenomena: phenomena.map(normalizePhenomenon),
                        ...restData
                    },
                    ...result
                }
            })
    },
    createPhenomenon: async (radarId, phenomenonData) => {
        return httpRequest(POST, `${radarId}/phenomenon`, normalizePhenomenonInput(phenomenonData))
            .then(({ data, ...result }) => {
                const { phenomenon, ...restData } = data

                return {
                    data: {
                        phenomenon: normalizePhenomenon(phenomenon),
                        ...restData
                    },
                    ...result
                }
            })
    },
    updatePhenomenon: async (radarId, phenomenonData) => {
        return httpRequest(PATCH, `${radarId}/phenomenon`, normalizePhenomenonInput(phenomenonData))
            .then(({ data, ...result }) => {
                const { phenomenon, ...restData } = data

                return {
                    data: {
                        phenomenon: normalizePhenomenon(phenomenon),
                        ...restData
                    },
                    ...result
                }
            })
    },
    deletePhenomenon: async (radarId, phenomenonData) => {
        return httpRequest(DELETE, `${radarId}/phenomenon`, phenomenonData)
    },
    // time ranges
    addRadarTimeRange: async (radarId, data) => {
        return httpRequest(POST, `${radarId}/time-range`, data)
    },
    updateRadarTimeRange: async (radarId, data) => {
        return httpRequest(PATCH, `${radarId}/time-range`, data)
    },
    deleteRadarTimeRange: async (radarId, data) => {
        return httpRequest(DELETE, `${radarId}/time-range`, data)
    },
    // sectors
    createSector: async (radarId, sectorData) => {
        return httpRequest(POST, `${radarId}/sector`, sectorData)
    },
    updateSector: async (radarId, sectorData) => {
        return httpRequest(PATCH, `${radarId}/sector`, sectorData)
    },
    deleteSector: async (radarId, sectorId, sectorData) => {
        return httpRequest(DELETE, `${radarId}/sector`, sectorData)
    }
}

export default radarDataApi
